/*
 * product-wheel-compat-trautis.js — Felgen-Kompatibilität (PDP-DOM-Glue).
 *
 * Rendert in snippet-wheel-compat-checker-trautis.liquid:
 *   - State-Divs [data-wkr-state] (match/conditional/no-match/unknown/unset)
 *   - Fahrzeug-Tabelle [data-wheel-table-body] (immer, variantenabhängig)
 *
 * Subscribes: trautis:variant-change (Section) + trautis:bmw-changed (document).
 * Matching: window.TrautisWheelFitment (trautis-wheel-fitment.js, muss vorher
 * geladen sein — Script-Reihenfolge in main-product-trautis.liquid).
 * Fahrzeug-DB: fetch über data-wheel-db-url (asset_url), Promise gecacht.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.TrautisWheelCompat = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') {
        root.document.addEventListener('DOMContentLoaded', api.init);
      } else {
        api.init();
      }
    }
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var SPEC_KEYS = ['lochkreis', 'lochanzahl', 'et_offset', 'felgenbreite_zoll', 'felgendurchmesser_zoll', 'zentrierung_mm'];

  var STATUS_LABEL = {
    'match': 'Passt',
    'conditional': 'Passt mit Hinweis',
    'unknown': 'Prüfung nötig',
    'no-match': 'Passt nicht',
  };

  function statusLabel(status) { return STATUS_LABEL[status] || status; }

  // Specs aus einer Variante des PDP-Produkt-JSON (Strings, '' = fehlt)
  function specsOf(variant) {
    var c = variant && variant.metafields && variant.metafields.custom;
    var out = {};
    for (var i = 0; i < SPEC_KEYS.length; i++) {
      out[SPEC_KEYS[i]] = c && c[SPEC_KEYS[i]] !== undefined ? c[SPEC_KEYS[i]] : null;
    }
    return out;
  }

  // Pure Zustands-Auflösung: testbar ohne DOM. matcher = TrautisWheelFitment.
  // productRules (optional, Phase 2): Gutachten-Regeln dieses Produkts als
  // { [chassis_code]: rules[] } — Durchreichung an den Matcher.
  function resolveWheelState(db, bmw, specs, matcher, productRules) {
    var rows = matcher.listVehicleMatches(db, specs, productRules);
    if (!bmw || !bmw.chassis) {
      return { state: 'unset', title: '', notes: [], rows: rows };
    }
    var vehicle = null;
    var vehicles = (db && db.vehicles) || [];
    for (var i = 0; i < vehicles.length; i++) {
      if (vehicles[i].chassis_code === bmw.chassis) { vehicle = vehicles[i]; break; }
    }
    var res = matcher.matchVariant(vehicle, specs, productRules);
    var label = bmw.label || bmw.chassis;
    var titles = {
      'match': 'Passt zu deinem ' + label,
      'conditional': 'Passt zu deinem ' + label + ' — mit Hinweis',
      'no-match': 'Passt nicht zu deinem ' + label,
      'unknown': 'Passung für deinen ' + label + ' bitte prüfen',
    };
    return { state: res.status, title: titles[res.status], notes: res.notes, rows: rows };
  }

  // --- DOM-Glue (im Node-Test nicht ausgeführt) ---

  var dbPromise = null;
  function loadDb(url) {
    if (!dbPromise) {
      dbPromise = fetch(url).then(function (r) {
        if (!r.ok) throw new Error('wheel db fetch failed: ' + r.status);
        return r.json();
      });
    }
    return dbPromise;
  }

  function getProductJSON(sectionRoot) {
    var s = sectionRoot.querySelector('script[type="application/json"][data-product-json]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function showState(el, name) {
    var states = el.querySelectorAll('[data-wkr-state]');
    states.forEach(function (st) {
      if (st.getAttribute('data-wkr-state') === name) st.removeAttribute('hidden');
      else st.setAttribute('hidden', '');
    });
  }

  // Glow-Ton fürs beruhigende Aufleuchten nach der Fahrzeugwahl: grün wenn die
  // Felge passt (auch „mit Hinweis"), sonst dezent-neutral — NIE alarmrot.
  // null = kein Glow (z.B. unset).
  function wheelGlowToneForState(state) {
    if (state === 'match' || state === 'conditional') return 'match';
    if (state === 'no-match' || state === 'unknown') return 'neutral';
    return null;
  }

  var GLOW_CLASSES = ['t-compat-checker--glow-match', 't-compat-checker--glow-neutral'];

  // Sanftes, langsames Aufleuchten (CSS) NACH dem Auflösen des Ergebnisses.
  function applyGlow(el, state) {
    var tone = wheelGlowToneForState(state);
    GLOW_CLASSES.forEach(function (c) { el.classList.remove(c); });
    if (!tone) return;
    void el.offsetWidth;
    el.classList.add('t-compat-checker--glow-' + tone);
    window.setTimeout(function () {
      el.classList.remove('t-compat-checker--glow-' + tone);
    }, 2800);
  }

  function renderRows(tbody, rows) {
    while (tbody.firstChild) tbody.removeChild(tbody.firstChild);
    rows.forEach(function (row) {
      var tr = tbody.ownerDocument.createElement('tr');
      var tdV = tbody.ownerDocument.createElement('td');
      tdV.textContent = row.chassis_code + (row.model_label ? ' · ' + row.model_label : '');
      var tdS = tbody.ownerDocument.createElement('td');
      tdS.textContent = statusLabel(row.status);
      var tdN = tbody.ownerDocument.createElement('td');
      tdN.textContent = row.notes.join(' ');
      tr.appendChild(tdV); tr.appendChild(tdS); tr.appendChild(tdN);
      tbody.appendChild(tr);
    });
  }

  function recompute(el, sectionRoot, eventVariant, opts) {
    var data = getProductJSON(sectionRoot);
    if (!data || !data.variants || data.variants.length === 0) return;

    var current = null;
    if (eventVariant && eventVariant.id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === eventVariant.id) { current = data.variants[i]; break; }
      }
    }
    if (!current && window.TrautisVariantReactivity) {
      var sectionId = sectionRoot.getAttribute('data-section-id');
      var v = window.TrautisVariantReactivity.getCurrentVariant(sectionId);
      if (v) {
        for (var j = 0; j < data.variants.length; j++) {
          if (data.variants[j].id === v.id) { current = data.variants[j]; break; }
        }
      }
    }
    if (!current) current = data.variants[0];

    var bmw = (window.TrautisFitment && typeof window.TrautisFitment.get === 'function') ? window.TrautisFitment.get() : null;
    if (bmw && !bmw.chassis) bmw = null;

    loadDb(el.getAttribute('data-wheel-db-url')).then(function (db) {
      // Phase 2 ersetzt das null durch die Gutachten-productRules des Produkts
      var res = resolveWheelState(db, bmw, specsOf(current), window.TrautisWheelFitment, null);
      var tableEl = el.querySelector('[data-wheel-table]');
      var tbody = el.querySelector('[data-wheel-table-body]');
      if (tbody) {
        renderRows(tbody, res.rows);
        if (tableEl) tableEl.removeAttribute('hidden');
      }
      if (res.state !== 'unset') {
        var stateEl = el.querySelector('[data-wkr-state="' + res.state + '"]');
        if (stateEl) {
          var t = stateEl.querySelector('[data-wkr-title]');
          if (t && res.title) t.textContent = res.title;
          var n = stateEl.querySelector('[data-wkr-notes]');
          if (n) n.textContent = res.notes.join(' ');
        }
      }
      showState(el, res.state);
      if (opts && opts.glow) applyGlow(el, res.state);
    }, function () {
      // DB-Fetch fehlgeschlagen → unset lassen statt falscher Aussage
      showState(el, 'unset');
    });
  }

  function initEl(el) {
    var sectionRoot = el.closest('[data-product-section]');
    if (!sectionRoot) return;

    var btn = el.querySelector('[data-wkr-open-bmw-modal]');
    if (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('trautis:open-bmw-selector', { detail: {} }));
      });
    }

    // Variantenwechsel + Initiallauf: still aktualisieren, KEIN Glow.
    sectionRoot.addEventListener('trautis:variant-change', function (e) {
      recompute(el, sectionRoot, e.detail && e.detail.variant);
    });
    // Fahrzeugwahl: aktualisieren UND beruhigend aufleuchten (Ergebnis-Ton).
    document.addEventListener('trautis:bmw-changed', function () {
      recompute(el, sectionRoot, null, { glow: true });
    });

    recompute(el, sectionRoot, null);
  }

  function init() {
    document.querySelectorAll('[data-wheel-compat]').forEach(initEl);
  }

  return {
    init: init,
    specsOf: specsOf,
    resolveWheelState: resolveWheelState,
    statusLabel: statusLabel,
    wheelGlowToneForState: wheelGlowToneForState,
  };
});
